/**
 * LIQUIDO's side of the shared poll-card.vue: everything the card needs, through the team API.
 * Provided once for the whole app in main.js. See src/shared/components/poll-card-api.js.
 */
import api from "@/liquido/services/liquido-graphql-client.js"

export default {
	reloadPoll: id => api.getPollById(id, true),
	currentUserId: () => api.getCachedUser()?.id,
	likeProposal: (pollId, proposalId) => api.likeProposal(pollId, proposalId),
}
